import { ApiConfig } from './environment.model';

export const apiCommon: ApiConfig = {
  uriSuffixe: '',
  urlBase: '',
  wsBaseUrl: 'wss',
  microservice: {
    PRODUIT: '/api-produit',
    DESIGN: '/api-design',
    SOUSCRIPTION: '/api-souscription',
    INSCRIPTION: '/api-inscription',
    PAYMENT: '/api-payment',
  },
  subResource: {
    PRODUCT: '/produit',
    PROJECT: '/project',
    'PRODUCT-TYPE': '/product-type',
    SOUSCRIPTION: '/souscription',
    POLICY: '/policy',
    COLOR: '/color',
    IMAGE: '/image',
    USER: '/user',
    OTP: '/otp',
    ACCOUNT: '/account',
    UPDATING: '/updating',
    SINISTER: '/sinistre',
    PARAMETER: '/parameter',
    NOTIFICATION: '/notification',
    SOCKET: '/mc',
    AGENCY: '/agency',
    INFO: '/info',
    BANK_ACCOUNT: '/bank-accounts',
    POLICY_DETAIL: '/v1/find-policy-detail',
    PROVIDER: '/provider',
    CURRENCY: '/currency',
    'PROVIDER-CURRENCY': '/provider-currency',
    TRANSACTION: '/transaction',
    PAYMENT: '/payment',
    DEVICES: '/devices',
    VERSION_APP: '/version-app',
  },
  uri: {
    CREATE: '/create',
    REGISTER: '/register',
    REGISTER_ANONYMOUS: '/register/anonymous',
    UPDATE: '/update',
    FIND_ALL: '/findall',
    FIND_BY: '/findby',
    FIND_BY_USER: '/findby/user',
    DEVIS: '/v1/devis',
    AFN: '/v1/afn',
    AFNV: '/v1/afnv',
    POLICY: '/v2/find',
    POLICY_DETAIL: '/v1/find-policy-detail',
    INITDATA: '/v1/initdata',
    PRINT: '/v1/print',
    FIND_USER_BY_PHONE: '/v1/get-by-realm/',
    OTP_REQUEST: '/v1/otp-send',
    OTP_VERIFY: '/v1/otp-verify',
    CREATE_USER: '/v1/create/',
    CHANGE_PASSWORD_USER: '/v1/reset-password/',
    GET_PROFILE: '/v1/get-profil/',
    GET_CONTRACTLESS_PROJECT: '/v2/contractless/find',
    DELETE_CONTRACTLESS_PROJECT: '/v1/delete',
    'EDIT-CODE-ASSURE': 'v1/edit-code-assure/',
    SYNC: '/v1/sync/',
    PAGINATED_NOTIFICATION: '/find/by/user/deleted/page',
    DELETE: '/delete',
    MASS_UPDATE: '/change-status',
    PAY: '/pay',
    CONSULT_POLICY: '/v1/life/consult',
    FREE_PAYMENT: '/v1/encaissement/versement',
    PERIODIC_PAYMENT: '/v1/encaissement/terme',
    UPDATE_PROFILE: '/v1/update-profile',
    GET_TRANSACTION_BY_ISSUER: '/find/by/issuer',
    GET_TRANSACTION_BY_ISSUER_PAGED: '/find/by/issuer/paged',
  },
};
